export const BenLocalStore = {
  set(key: string, data: any, { type = 'session' as 'session' | 'local' } = {}) {
    const storage = type === 'local' ? localStorage : sessionStorage
    storage.setItem(key, JSON.stringify(data))
  },

  get(key: string, { type = 'session' as 'session' | 'local' } = {}) {
    const storage = type === 'local' ? localStorage : sessionStorage
    const data = storage.getItem(key)
    if (data === null) return null
    try {
      return JSON.parse(data)
    } catch (e) {
      console.error(`解析 ${key} 的数据失败:`, e)
      return null
    }
  },

  /**
   * 将 sessionStorage 中的所有数据复制到 localStorage
   * @param options.clear - 是否清除 sessionStorage 中的数据，默认 true
   */
  copySessionToLocal({ clear = true } = {}) {
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i)
      if (key) {
        const value = sessionStorage.getItem(key)
        if (value !== null) {
          localStorage.setItem(key, value)
        }
      }
    }
    if (clear) {
      sessionStorage.clear()
    }
  },

  copyLocalToSession({ clear = true } = {}) {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key) {
        const value = localStorage.getItem(key)
        if (value !== null) {
          sessionStorage.setItem(key, value)
        }
      }
    }
    if (clear) {
      localStorage.clear()
    }
  },

  // 可以添加删除方法完善功能
  remove(key: string, { type = 'session' as 'session' | 'local' } = {}) {
    const storage = type === 'local' ? localStorage : sessionStorage
    storage.removeItem(key)
  },

  // 清空存储
  clear({ type = 'session' as 'session' | 'local' } = {}) {
    const storage = type === 'local' ? localStorage : sessionStorage
    storage.clear()
  },
}
